import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
//* Material UI
import withStyles from '@material-ui/core/styles/withStyles'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
//* Redux
import { useDispatch, useSelector } from 'react-redux'
import { submitComment } from '../../redux/actions/dataActions'

const styles = (theme) => ({
  ...theme.spreadThis,
})

const CommentForm = ({ classes, chirpId }) => {
  //* Redux
  const dispatch = useDispatch()
  const { errors: errorsUI, loading: loadingUI } = useSelector(
    (state) => state.UI
  )
  const { authenticated } = useSelector((state) => state.user)
  //* State
  const [body, setBody] = useState('')
  const [errors, setErrors] = useState({})

  //* UseEffect
  useEffect(() => {
    if (errorsUI) {
      setErrors(errorsUI)
    }
    if (!errorsUI && !loadingUI) {
      setBody('')
    }
  }, [errorsUI, loadingUI])

  //* Event Handlers
  const handleSubmit = async (event) => {
    event.preventDefault()
    await dispatch(submitComment(chirpId, { body: body }))
    setBody('')
  }

  const commentFormMarkup = authenticated ? (
    <Grid item sm={12} style={{ textAlign: 'center' }}>
      <form onSubmit={handleSubmit}>
        <TextField
          name='body'
          type='text'
          label='Comment on chirp'
          error={errors.comment ? true : false}
          helperText={errors.comment}
          value={body}
          onChange={(e) => setBody(e.target.value)}
          fullWidth
          className={classes.textField}
        />
        <Button
          type='submit'
          variant='contained'
          color='primary'
          className={classes.button}
        >
          Submit
        </Button>
      </form>
      <br />
    </Grid>
  ) : null

  return commentFormMarkup
}

CommentForm.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(CommentForm)
